 <app-navbar></app-navbar>

<div class="dashboard-container">
  <app-tabs
    [tabs]="dashboardTabs"
    [routingStyle]="'path'"
    [defaultTab]="'DonorOverview'"
    (tabChanged)="onTabChange($event)"
  ></app-tabs>

  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
